/**
 * Created by Languagenut on 21/03/2019.
 */

import React from 'react'
import {
    HashRouter,
    Route,
    Routes
  } from "react-router-dom";
import {SignupCn, Inschrijven, Signup, EU, Dollar, Problem, Success, COVID, Payment, SignupNewZealand, SignupGlobal, SignupAustralia, SignupIreland } from './screens';
import ReactGA from 'react-ga';
ReactGA.initialize('UA-11083377-37');

export default class ApplicationRouter extends React.Component {

    constructor(props) {
        super();
        this.state = {
            gotTranslations: false,
            authenticated: false
        }
    }

    componentWillMount() {

    }

    componentDidMount() {
        ReactGA.pageview(window.location.pathname + window.location.hash);
    }

    render() {

        return <div className="container" style={{ paddingTop: "20px" }}>
            <HashRouter>
            <Routes>
                <Route exact path="/" element={<COVID></COVID>} />
                <Route exact path="/global" element={<Dollar></Dollar>} />
                <Route exact path="/eu" element={<EU></EU>} />

                <Route exact path="/signup" element={<Signup></Signup>} />
                <Route exact path="/signupcn" element={<SignupCn></SignupCn>} />
                <Route exact path="/inschrijven" element={<Inschrijven></Inschrijven>} />
                <Route exact path="/signupnewzealand" element={<SignupNewZealand></SignupNewZealand>} />
                <Route exact path="/signupglobal" element={<SignupGlobal></SignupGlobal>} />
                <Route exact path="/signupaustralia" element={<SignupAustralia></SignupAustralia>} />
                <Route exact path="/signupireland" element={<SignupIreland></SignupIreland>} />

                <Route exact path="/payment" element={<Payment></Payment>} />
                <Route exact path="/success" element={<Success></Success>} />
                <Route exact path="/problem" element={<Problem></Problem>} />
                </Routes>
            </HashRouter>
        </div>

    }
}
